<template>
  <div>
    <div class="d-flex justify-content-end mb-4">
      <b-button variant="success" @click="downloadForm()">
        <CIcon name="cil-cloud-download" />
        Download Excel Form
      </b-button>
    </div>

    <div class="container-fluid d-flex align-items-center justify-content-center min-vh-80 -pt-5">
      <div class="upload-box glass-box text-center p-5" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop" :class="{ dragging: isDragging }">
        <div class="cloud-icon mb-4">
          <i class="fa fa-cloud-upload fa-5x text-primary"></i>
        </div>

        <h4 class="mb-3">{{ $store.state.text.import_drag }}</h4>

        <p class="text-muted">{{ $store.state.text.import_text }}</p>

        <input type="file" ref="fileInput" class="d-none" @change="onFileChange" />

        <div class="mt-3">
          <button class="btn btn-outline-primary mr-2" @click="$refs.fileInput.click()">Choose File</button>

          <button v-if="file" class="btn btn-primary" @click="uploadFiles">Upload</button>
        </div>

        <ul class="list-group mt-4" v-if="file">
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <div>
              {{ file.name }}
              <span class="badge badge-primary badge-pill ml-2"> {{ (file.size / 1024).toFixed(1) }} KB </span>
            </div>

            <button class="btn btn-sm btn-danger" @click="removeFile">✕</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Upload",
  data() {
    return {
      isDragging: false,
      file: null,
    };
  },
  methods: {
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(e) {
      this.isDragging = false;
      this.addFile(e.dataTransfer.files[0]);
    },
    onFileChange(e) {
      this.addFile(e.target.files[0]);
    },
    addFile(file) {
      this.file = file;
    },
    removeFile() {
      this.file = null;
      this.$refs.fileInput.value = null;
    },
    async uploadFiles() {
      let vm = this;
      let formData = new FormData();

      formData.append("excel1", vm.file);

      vm.$axios
        .post("dataKaryawan/readExcel", formData)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = this.$store.state.form.simpan;
            vm.busy = false;
            vm.$store.commit("set_alert", {
              variant: "success",
              msg: "BERHASIL IMPORT DATA KARYAWAN",
              showing: true,
            });
            this.removeFile();
          } else {
            vm.$store.commit("set_alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.$store.commit("set_alert", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        });
    },
    async downloadForm() {
      try {
        const res = await this.$axios.get("dataKaryawan/downloadExcel", {
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Data Karyawan Import Form.xlsx"; // file name
        a.click();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.upload-box {
  width: 60%;
  max-width: 700px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 2px dashed #007bff;
  transition: all 0.3s ease;
  cursor: pointer;
}

/* 🌟 Glass effect (more transparent) */
.glass-box {
  background: rgba(255, 255, 255, 0.15); /* more transparent */
  border-radius: 20px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

/* 🔥 Glow effect when dragging */
.upload-box.dragging {
  border-color: #00bfff;
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 0 25px rgba(0, 191, 255, 0.6);
  transform: scale(1.02);
}

/* Optional hover effect for mouse (not only drag) */
.upload-box:hover {
  border-color: #3399ff;
  box-shadow: 0 0 15px rgba(0, 153, 255, 0.4);
}

.cloud-icon {
  font-size: 80px;
}
</style>
